import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Icon from "../components/Icon";
import { Button } from "../components/ui";
import { useAuth } from "../auth";
import { apiGet } from "../api";
import { useI18n } from "../i18n";
import { C, S } from "../theme";

export default function BillingSuccess() {
  const { t: tr } = useI18n();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [phase, setPhase] = useState("checking");
  const [info, setInfo] = useState({});
  const attempts = useRef(0);

  useEffect(() => {
    let cancelled = false;
    if (!sessionId) { setPhase("error"); return; }
    const poll = async () => {
      try {
        const res = await apiGet(`/checkout/status/${sessionId}`);
        if (cancelled) return;
        setInfo({ tier_label: res.tier_label, period: res.period });
        if (res.payment_status === "paid") { await refresh(); setPhase("paid"); return; }
        if (res.status === "expired") { setPhase("pending"); return; }
        attempts.current += 1;
        if (attempts.current >= 8) { setPhase("pending"); return; }
        setTimeout(poll, 2000);
      } catch { if (!cancelled) setPhase("error"); }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const wrap = { minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: S.xl, textAlign: "center" };
  const iconWrap = (bg) => ({ width: 96, height: 96, borderRadius: 28, background: bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: S.lg });

  return (
    <div style={wrap}>
      {phase === "checking" && (<><div style={{ color: C.amber, fontSize: 40 }}>⏳</div><div className="display" style={{ color: C.text, fontSize: 24, fontWeight: 900, marginTop: S.md }}>{tr("billing.confirming")}</div><div style={{ color: C.muted, marginTop: S.sm }}>{tr("billing.confirmingSub")}</div></>)}
      {phase === "paid" && (<><div style={iconWrap(C.green)}><Icon name="checkmark" size={54} color={C.black} /></div><div className="display" style={{ color: C.text, fontSize: 24, fontWeight: 900 }}>{tr("billing.allSet")}</div><div style={{ color: C.muted, marginTop: S.sm, lineHeight: 1.4 }}>{info.tier_label || "plan"} ({info.period || "monthly"}) {tr("billing.active")}</div><div style={{ height: S.xl }} /><div style={{ width: 280 }}><Button title={tr("billing.goDashboard")} testID="success-continue" onPress={() => nav("/dashboard")} /></div></>)}
      {phase === "pending" && (<><div style={iconWrap(C.amber)}><Icon name="time" size={50} color={C.black} /></div><div className="display" style={{ color: C.text, fontSize: 24, fontWeight: 900 }}>{tr("billing.processing")}</div><div style={{ color: C.muted, marginTop: S.sm, lineHeight: 1.4 }}>{tr("billing.processingSub")}</div><div style={{ height: S.xl }} /><div style={{ width: 280 }}><Button title={tr("billing.backToPlans")} variant="dark" testID="success-back" onPress={() => nav("/paywall")} /></div></>)}
      {phase === "error" && (<><div style={iconWrap(C.red)}><Icon name="close" size={50} color={C.text} /></div><div className="display" style={{ color: C.text, fontSize: 24, fontWeight: 900 }}>{tr("billing.wentWrong")}</div><div style={{ color: C.muted, marginTop: S.sm }}>{tr("billing.couldNotVerify")}</div><div style={{ height: S.xl }} /><div style={{ width: 280 }}><Button title={tr("billing.backToPlans")} variant="dark" testID="success-back" onPress={() => nav("/paywall")} /></div></>)}
    </div>
  );
}
